import instance from 'Shared/api/instance';

export function fetchSmartLinkTitle(url: string) {
  return instance.get(`/api/v0/smart_links/enrich_url?url=${encodeURIComponent(url)}`);
}
